import { Fragment } from 'react';
import StaffCreateFormView from '../../../components/payroll/create/staff/StaffCreateFormView';
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';

const PayrollStaffCreateListView = () => {
  const { data, loading, error, refetch } = useFetchData(AppURL.PayrollURL + 'payroll/staff/create/designation/options/view/');
  const handleFormSuccess = (): void => {
    refetch();
  };
  return (
    <Fragment>
      <StaffCreateFormView data={data} handleFormSuccess={handleFormSuccess} />
    </Fragment>
  )
}

export default PayrollStaffCreateListView